import { LIST_OF_GET_PARAMS_TO_SAVE } from 'src/common/config'
import { getConfig } from 'src/configs'

const config = getConfig()

export default async () => {
  // Вынужденная мера с бесконечным ожиданием для того чтобы не выполнялся код boot при редиректе лицензии anj dev-3239
  if (window.location.hostname === config.mainDomain && window.location.href.includes('/check-license-anj')) {
    await new Promise(() => {})
  }

  storeQueryParams()
}

function storeQueryParams() {
  const params = new Proxy(new URLSearchParams(window.location.search), {
    get: (searchParams, prop) => searchParams.get(prop)
  })

  for (const param of Object.keys(LIST_OF_GET_PARAMS_TO_SAVE)) {
    const paramValue = params[param]
    if (paramValue) {
      try {
        const storage = LIST_OF_GET_PARAMS_TO_SAVE[param]
        storage.setItem(param, paramValue)
      } catch (e) {
        console.error(e)
      }
    }
  }
}
